module.exports = __webpack_public_path__ + "img/sp.5a6c0965.svg";